import { IReduxAction } from "../../utils/interfaces";
import { updateState } from "../../utils/reduxUtils";
import {
  CREATE_MEDICATION_TEMPLATE_SUCCESS,
  DELETE_MEDICATION_TEMPLATE_SUCCESS,
  GET_MEDICATION_TEMPLATE_SUCCESS,
  GET_MEDICATION_TEMPLATES_SUCCESS,
  UPDATE_MEDICATION_TEMPLATE_SUCCESS,
} from "../actions";

const initialState = {
  templates: null,
  current: null,
};

export const medicationTemplatesReducer = (
  state = initialState,
  { type, payload }: IReduxAction
) => {
  switch (type) {
    case GET_MEDICATION_TEMPLATES_SUCCESS: {
      return updateState(state, payload);
    }
    case GET_MEDICATION_TEMPLATE_SUCCESS: {
      return updateState(state, payload);
    }
    case DELETE_MEDICATION_TEMPLATE_SUCCESS:
    case UPDATE_MEDICATION_TEMPLATE_SUCCESS:
    case CREATE_MEDICATION_TEMPLATE_SUCCESS:
      return {...state, current: null};
    default: {
      return state;
    }
  }
};
